import React from 'react';
// Icons
import { FaTwitter } from 'react-icons/fa';
// Constants
import { TWITTER_URL } from '../../utils/Constants';

function FooterSocialCTA() {
  const navigateToSocialMedia = (url) => {
    window.open(url, '_blank');
  };

  const socialMediaLinks = [
    // {
    //   serviceName: 'Instagram',
    //   icon: <FaInstagram className='w-8 h-8 text-colour4' />,
    //   url: INSTAGRAM_BUSINESS_URL,
    // },
    {
      serviceName: 'Twitter',
      icon: <FaTwitter className='w-8 h-8 text-colour4' />,
      url: TWITTER_URL,
    },
  ];

  return (
    <section className='grid justify-center'>
      <div className='grid grid-flow-col w-fit gap-3'>
        {socialMediaLinks.map((social) => (
          <button
            key={social.serviceName}
            onClick={() => navigateToSocialMedia(social.url)}
            className='rounded-full shadow-lg hover:scale-105 transition-transform'
          >
            {social.icon}
          </button>
        ))}
      </div>
    </section>
  );
}

export default FooterSocialCTA;
